import React, { useEffect, useState } from 'react';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';
import { Slide } from 'react-toastify';
import classNames from 'classnames';
import { copyToClipboard } from 'v3/common/utils/copyToClipBoard';

interface CopyTextButtonProps {
  text: string;
  disabled?: boolean;
  className?: string;
  successText?: string;
  children?: React.ReactNode;
}

const CopyTextButton: React.FC<CopyTextButtonProps> = ({
  text,
  successText,
  disabled,
  className,
  children,
}) => {
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    if (isClicked) {
      const timer = setTimeout(() => {
        setIsClicked(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isClicked]);

  const onCopy = () => {
    const toasterConfig = { autoClose: 1500, hideProgressBar: true, transition: Slide };

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          reactToastify(successText || 'Copied to clipboard', TOASTIFY_TYPES.SUCCESS, toasterConfig);
          setIsClicked(true);
        })
        .catch(() => {
          reactToastify('Failed to copy text', TOASTIFY_TYPES.ERROR, toasterConfig);
        });
    } else {
      copyToClipboard(text, successText);
      setIsClicked(true);
    }
  };

  const btnClassName = classNames('global-copy-btn', className);

  return (
    <button className={btnClassName} onClick={onCopy} disabled={disabled}>
      <span className="copy-btn__text">{children}</span>
      <span className="copy-btn__icon">
        {isClicked ? <i className="fa-regular fa-check" /> : <i className="fa-regular fa-copy" />}
      </span>
    </button>
  );
};

export default CopyTextButton;
